// 統一處理 session 過期：後端會 302 redirect 到 /Login，或直接回 401
const checkAuth = (response) => {
    if (response.status === 401 || response.redirected) {
        window.location.href = '/';
        return Promise.reject(new Error('Session expired'));
    }
    return response;
}

const getData = (url, data = {}) => {
    url += '?' + (new URLSearchParams(data)).toString();

    return fetch(url)
        .then(res => checkAuth(res))
        .then(res => res.json())
}

const postFile = (url, file) => {
    const formData = new FormData();
    formData.append('files', file);

    return fetch(url, {
        method: 'POST',
        body: formData,
    })
    .then(res => checkAuth(res))
    .then((response) => response.json())
}

const postData = (url, data) => {
    // Default options are marked with *
    return fetchData(url, data, "POST")
    .then(res => checkAuth(res))
    .then(response => response.json()) // 輸出成 json
}

const patchData = (url, data) => {
    // Default options are marked with *
    return fetchData(url, data, "PATCH")
    .then(res => checkAuth(res))
        .then(response => response.json()) // 輸出成 json
}

const deleteData = (url, data) => {
    // Default options are marked with *
    return fetchData(url, data, "DELETE")
    .then(res => checkAuth(res))
        .then(response => response.json()) // 輸出成 json
}

const fetchData = (url, data, method) => {
    // Default options are marked with *
    return fetch(url, {
        body: JSON.stringify(data), // must match 'Content-Type' header
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, same-origin, *omit
        headers: {
            'user-agent': 'Mozilla/4.0 MDN Example',
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        method: method, // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
    })
}

export { postData, getData, postFile, deleteData, patchData }